import React from 'react';
import {HStack, Image, Tabs} from '@chakra-ui/react';
import {useLanguage} from "@/contexts/languageContext";
import flags from "@/assets/images/flags";

export const LanguageInput = ({id, renderElement, label = null, defaultLanguage = null}) => {
    const {language, availableLanguages} = useLanguage();
    return (
        <Tabs.Root overflow="hidden" display="flex" flexDirection="column" flex={1} w="100%" defaultValue={defaultLanguage ?? language} variant="enclosed">
            <HStack>
                { label ? label : null}
                <Tabs.List h="8" alignSelf="center">
                    {
                        availableLanguages.map((lang) => <Tabs.Trigger h="100%" px="2" py="0" key={`tabs-${id}-header-${lang}`} value={lang}>
                            <Image src={flags?.[lang]} alt={lang}/>
                        </Tabs.Trigger>)
                    }
                </Tabs.List>
            </HStack>
            {
                availableLanguages.map((lang) => <Tabs.Content pt="1" display="flex" key={`tabs-${id}-content-${lang}`} flex={1} value={lang}>
                    {
                        renderElement(lang)
                    }
                </Tabs.Content>)
            }
        </Tabs.Root>

    );
};

export default LanguageInput;
